import createReducer from '../../reducers/utils/createReducer';
import * as c from './types';

const initialState = {
  data: {},
  sensorData: {},
  isLoading: false,
  error: null
};

export default createReducer(initialState, {
  [c.GET_YESTERDAY_MACHINES_SHIFTS_REQUEST]: (state = initialState) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_YESTERDAY_MACHINES_SHIFTS_SUCCESS]: (
    state = initialState,
    { payload }
  ) => {
    if (!payload) return state;
    return {
      ...state,
      data: payload,
      isLoading: false
    };
  },
  [c.GET_YESTERDAY_MACHINES_SHIFTS_ERROR]: (
    state = initialState,
    { payload }
  ) => {
    if (!payload) return state;
    return {
      ...state,
      error: payload,
      isLoading: false
    };
  }
});
